module.exports = __webpack_public_path__ + "static/media/img-b2c29bd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/png/visitTypePlaceholder.png
// module id = 5266
// module chunks = 39